<template>
  <section class="privacy-page">
    <!-- Hero Section -->
    <div class="privacy-hero">
      <div class="hero-content">
        <h1 class="hero-title">
          {{ $t?.('privacy.title') || 'Política de Privacidade' }}
        </h1>
        <p class="hero-subtitle">
          {{ $t?.('privacy.subtitle') || 'Protección de datos persoais e dereitos dos usuarios' }}
        </p>
      </div>
    </div>

    <!-- Content Section -->
    <div class="privacy-content section">
      <div class="container">
        <Card variant="elevated" padding="lg" class="content-card">
          <div class="legal-content">
            
            <!-- 1. Información al Usuario -->
            <div class="legal-section">
              <h2 class="section-title">1. {{ $t?.('privacy.userInfoTitle') || 'Información ao Usuario' }}</h2>
              
              <h3 class="subsection-title">{{ $t?.('privacy.responsibleQuestion') || 'Quen é o responsable do tratamento dos teus datos persoais?' }}</h3>
              <div class="section-text" v-html="$t?.('privacy.responsibleText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('privacy.purposeQuestion') || 'Para que tratamos os teus datos persoais e por que o facemos?' }}</h3>
              <div class="section-text" v-html="$t?.('privacy.purposeText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('privacy.durationQuestion') || 'Durante canto tempo gardaremos os teus datos persoais?' }}</h3>
              <div class="section-text" v-html="$t?.('privacy.durationText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('privacy.recipientsQuestion') || 'A quen facilitamos os teus datos persoais?' }}</h3>
              <div class="section-text" v-html="$t?.('privacy.recipientsText') || ''"></div>

              <h3 class="subsection-title">{{ $t?.('privacy.rightsQuestion') || 'Cales son os teus dereitos?' }}</h3>
              <div class="section-text">{{ $t?.('privacy.rightsIntro') || 'Os dereitos que asisten ao USUARIO son:' }}</div>
              <ul class="rights-list">
                <li>{{ $t?.('privacy.rightWithdraw') || 'Dereito a retirar o consentimento en calquera momento.' }}</li>
                <li>{{ $t?.('privacy.rightAccess') || 'Dereito de acceso, rectificación, portabilidade e supresión dos seus datos, e de limitación ou oposición ao seu tratamento.' }}</li>
                <li>{{ $t?.('privacy.rightComplaint') || 'Dereito a presentar unha reclamación ante a autoridade de control (www.aepd.es) se considera que o tratamento non se axusta á normativa vixente.' }}</li>
              </ul>

              <div class="contact-box">
                <h4>{{ $t?.('privacy.contactTitle') || 'Datos de contacto para exercer os seus dereitos:' }}</h4>
                <p><strong>Banda de Música de Noia</strong></p>
                <p>Rúa Vizconde de San Alberto, s/n - 15200 Noia</p>
                <p>
                  <strong>Email:</strong> 
                  <a href="#" @click.prevent="copyEmail" class="email-link">
                    bandadenoia<span class="email-separator"> [arroba] </span>gmail.com
                  </a>
                  <span class="email-hint">(Click para copiar)</span>
                </p>
              </div>
            </div>

            <!-- 2. Carácter obligatorio o facultativo -->
            <div class="legal-section">
              <h2 class="section-title">2. {{ $t?.('privacy.mandatoryTitle') || 'Carácter Obrigatorio ou Facultativo da Información Facilitada polo Usuario' }}</h2>
              
              <div class="section-text" v-html="$t?.('privacy.mandatoryText1') || ''"></div>
              <div class="section-text" v-html="$t?.('privacy.mandatoryText2') || ''"></div>

              <div class="info-box">
                <p><strong><i class="fas fa-asterisk"></i> {{ $t?.('privacy.mandatoryNote') || 'Campos marcados con asterisco (*)' }}</strong></p>
                <p>{{ $t?.('privacy.mandatoryNoteText') || 'Os campos marcados con asterisco (*) nos formularios son obrigatorios, xa que son necesarios para a prestación dun servizo óptimo ao USUARIO. En caso de que non se faciliten todos os datos, non se garante que a información e servizos facilitados sexan completamente axustados ás súas necesidades.' }}</p>
              </div>
            </div>

            <!-- 3. Medidas de Seguridad -->
            <div class="legal-section">
              <h2 class="section-title">3. {{ $t?.('privacy.securityTitle') || 'Medidas de Seguridade' }}</h2>
              
              <div class="section-text" v-html="$t?.('privacy.securityText1') || ''"></div>
              <div class="section-text" v-html="$t?.('privacy.securityText2') || ''"></div>

              <div class="contact-box">
                <h4><i class="fas fa-shield-alt"></i> {{ $t?.('privacy.securityContactTitle') || 'Para máis información sobre as garantías de privacidade' }}</h4>
                <p>Podes dirixirte ao RESPONSABLE a través de:</p>
                <p><strong>Banda de Música de Noia</strong></p>
                <p>Rúa Vizconde de San Alberto, s/n - 15200 Noia</p>
                <p>
                  <strong>Email:</strong> 
                  <a href="#" @click.prevent="copyEmail" class="email-link">
                    bandadenoia<span class="email-separator"> [arroba] </span>gmail.com
                  </a>
                  <span class="email-hint">(Click para copiar)</span>
                </p>
              </div>
            </div>

            <!-- Normativa Aplicable -->
            <div class="legal-section">
              <h2 class="section-title">{{ $t?.('privacy.regulationsTitle') || 'Normativa Aplicable' }}</h2>
              
              <div class="regulations-box">
                <ul class="regulations-list">
                  <li>
                    <strong>RGPD:</strong> Regulamento (UE) 2016/679 do Parlamento Europeo e do Consello, do 27 de abril de 2016, relativo á protección das persoas físicas no que respecta ao tratamento de datos persoais e á libre circulación destes datos.
                  </li>
                  <li>
                    <strong>LOPDGDD:</strong> Lei Orgánica 3/2018, do 5 de decembro, de Protección de Datos Persoais e garantía dos dereitos dixitais.
                  </li>
                </ul>
              </div>
            </div>

            <!-- Last Update -->
            <div class="last-update">
              <i class="fas fa-calendar-alt"></i>
              {{ $t?.('privacy.lastUpdate') || 'Última actualización' }}: {{ currentDate }}
            </div>
          </div>
        </Card>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
import { useHead } from '@vueuse/head';
import Card from '../ui/Card.vue';
import { buildHeadConfig, getBreadcrumbJsonLd } from '../../seo/meta';

// Access i18n
const instance = getCurrentInstance();
const $t = instance?.appContext.config.globalProperties.$t;

useHead(
  buildHeadConfig('privacy', {
    jsonLd: [getBreadcrumbJsonLd('privacy')],
  }),
)

// Current date for last update
const currentDate = computed(() => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  return `${day}-${month}-${year}`;
});

// Copy email function
const copyEmail = async () => {
  const email = 'bandadenoia@gmail.com';
  try {
    await navigator.clipboard.writeText(email);
    alert('✓ Email copiado ao portapapeis!');
  } catch (err) {
    const textArea = document.createElement('textarea');
    textArea.value = email;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    alert('✓ Email copiado ao portapapeis!');
  }
};
</script>

<style scoped>
/* Privacy Page */
.privacy-page {
  background: white;
}

/* Hero Section */
.privacy-hero {
  position: relative;
  min-height: 35vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-band);
  overflow: hidden;
  padding: var(--spacing-16) var(--spacing-4);
}

.privacy-hero::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.hero-title {
  font-size: clamp(2.5rem, 6vw, 4rem);
  font-weight: var(--font-weight-bold);
  color: white;
  margin-bottom: var(--spacing-4);
  font-family: var(--font-family-serif);
  line-height: 1.1;
  text-align: center;
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.25rem);
  color: rgba(255, 255, 255, 0.95);
  font-weight: var(--font-weight-medium);
  text-align: center;
}

/* Content Section */
.privacy-content {
  padding: var(--spacing-20) 0;
  background: var(--color-neutral-50);
}

.content-card {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--spacing-6);
}

.legal-content {
  color: var(--color-text-primary);
  line-height: 1.8;
  padding: var(--spacing-8);
}

/* Sections */
.legal-section {
  margin-bottom: var(--spacing-12);
  padding-bottom: var(--spacing-8);
  border-bottom: 1px solid var(--color-neutral-200);
}

.legal-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
}

.section-title {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-primary-700);
  margin: 0 0 var(--spacing-6) 0;
  font-family: var(--font-family-serif);
}

.subsection-title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-primary-600);
  margin: var(--spacing-6) 0 var(--spacing-4) 0;
  font-family: var(--font-family-serif);
}

.section-text {
  margin-bottom: var(--spacing-4);
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  text-align: justify;
  line-height: 1.8;
}

/* Lists */
.rights-list {
  list-style: none;
  padding: 0;
  margin: var(--spacing-4) 0;
}

.rights-list li {
  padding: var(--spacing-3) 0 var(--spacing-3) var(--spacing-8);
  border-left: 3px solid var(--color-primary-200);
  margin-bottom: var(--spacing-3);
  position: relative;
  color: var(--color-text-secondary);
}

.rights-list li::before {
  content: '●';
  position: absolute;
  left: var(--spacing-3);
  color: var(--color-primary-500);
  font-size: 0.8em;
}

.regulations-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.regulations-list li {
  padding: var(--spacing-4);
  margin-bottom: var(--spacing-3);
  background: white;
  border-radius: var(--border-radius-lg);
  border-left: 4px solid var(--color-primary-500);
  box-shadow: var(--shadow-sm);
}

.regulations-list li strong {
  color: var(--color-primary-700);
  display: block;
  margin-bottom: var(--spacing-2);
  font-size: var(--font-size-lg);
}

/* Info Box */
.info-box {
  background: var(--color-secondary-50);
  border: 1px solid var(--color-secondary-200);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-6);
  margin: var(--spacing-10) 0;
  border-left: 4px solid var(--color-secondary-500);
}

.info-box p {
  margin: var(--spacing-2) 0;
  color: var(--color-text-secondary);
}

.info-box strong {
  color: var(--color-secondary-700);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.info-box i {
  color: var(--color-secondary-600);
}

/* Regulations Box */
.regulations-box {
  background: var(--color-primary-50);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-6);
  margin: var(--spacing-6) 0;
}

/* Contact Box */
.contact-box {
  background: var(--color-neutral-50);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-6);
  margin: var(--spacing-10) 0;
  border-left: 4px solid var(--color-primary-500);
}

.contact-box h4 {
  margin: 0 0 var(--spacing-4) 0;
  color: var(--color-primary-700);
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}

.contact-box h4 i {
  color: var(--color-primary-500);
}

.contact-box p {
  margin: var(--spacing-2) 0;
  color: var(--color-text-secondary);
}

.email-link {
  color: var(--color-primary-600);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.email-link:hover {
  text-decoration: underline;
}

.email-separator {
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-normal);
}

.email-hint {
  display: inline-block;
  margin-left: var(--spacing-2);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  font-style: italic;
}

/* Last Update */
.last-update {
  margin-top: var(--spacing-10);
  padding: var(--spacing-4) var(--spacing-6);
  background: rgba(79, 148, 160, 0.1);
  border-left: 4px solid var(--color-primary-500);
  border-radius: var(--border-radius-md);
  font-size: var(--font-size-sm);
  color: var(--color-primary-700);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  font-weight: var(--font-weight-medium);
}

.last-update i {
  color: var(--color-primary-500);
}

/* Responsive */
@media (max-width: 768px) {
  .privacy-hero {
    min-height: 30vh;
  }

  .section-title {
    font-size: var(--font-size-xl);
  }

  .subsection-title {
    font-size: var(--font-size-lg);
  }

  .section-text {
    text-align: left;
  }
}

/* Refresh 2026 - visual coherence with Home */
.privacy-page {
  background: transparent;
}

.privacy-hero {
  min-height: 40vh;
  padding: clamp(2.4rem, 5.4vw, 4.3rem) var(--spacing-4);
  background:
    radial-gradient(circle at 84% 14%, rgba(219, 174, 80, 0.2), rgba(219, 174, 80, 0) 42%),
    linear-gradient(132deg, #10293b 0%, #1a3c54 52%, #2f6285 100%);
}

.privacy-hero::before {
  background: radial-gradient(circle at 18% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 45%);
}

.privacy-content {
  background: transparent;
}

.content-card {
  background: var(--surface-card-strong);
  border: 1px solid rgba(16, 41, 59, 0.12);
  box-shadow: var(--shadow-xl);
}

.contact-box,
.regulations-box,
.info-box {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(16, 41, 59, 0.12);
}

.regulations-list li {
  background: rgba(255, 255, 255, 0.88);
}

.last-update {
  background: rgba(26, 79, 113, 0.12);
}
</style>
